// İSG uzmanı portalı — self-profil (`GET /me`) TanStack Query anahtarı (api-contract
// §18.1). Kullanıcı tek firmaya bağlıdır (token `companyId` oturum boyunca sabit);
// bu yüzden anahtar parametresizdir. Profil nadiren değişir — uzun `staleTime`.

export const meKeys = {
  /** Giriş yapan kullanıcının kendi profili (`GET /me`). */
  me: () => ['me'] as const,
} as const;
